import { RouteObject, useNavigate } from "react-router-dom";
import UtilitySetupLanding from "./components/landing/landing";
import CoreSystemSettings from "./components/core-system/landing/CoreSystemSettings";
import IdConfigLanding from "./components/ID-config/ID-config";
import UserMgmtLanding from "./components/user-mgmt/components/UserMgmtLanding";
import CalenderLanding from "./components/calender-schedule/landing";
import UtilityAdminDashboard from "./components/utility-dashboard/UtilityAdminDashboard";
import { TariffAddForm } from "./components/plan-tariffs/components/Tarrif/TariffAddForm";
import TarrifList from "./components/plan-tariffs/components/Tarrif/TarrifList";
import PlanStepper from "./components/plan-tariffs/components/Plan/PlanStepper";
// import PlansAndTariffLanding from "./components/plan-tariffs/components/landing/landing";
import RateDetailComponent from "./components/plan-tariffs/components/Tarrif/RateDetailComponent";
import ServiceAreaLanding from "./components/service-area-mgmt/landing/Landing";
import EntityDetailView from "./components/service-area-mgmt/view/EntityDetailView";
import UnitDetailView from "./components/service-area-mgmt/view/unitDetails/details";
import PlanDetailsView from "./components/plan-tariffs/components/Plan/PlanView";
import PlansAndTariffLanding from "../plan-rates/components/landing/landing";
import CreatePlan from "../plan-rates/components/plan/components/create/Create";
import ParameterRegistryList from "./components/core-system/parameterRegistry/List";
import BulkEditPlanStepper from "../plan-rates/components/plan/components/bulkEdit/Edit";
import { PlanDetailLanding } from "../plan-rates/components/plan/components/detail/Landing";
export interface UtilitySetupRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: UtilitySetupRoute[];
}

const ServiceAreaDetailRoute = () => {
  const navigate = useNavigate();
  return (
    <EntityDetailView
      onBack={() => navigate("/utility/utility-setup/service-area?tab=premises")}
    />
  );
};

export const utilitySetupRoutes: UtilitySetupRoute[] = [
  {
    path: "/utility/utility-setup/dashoard",
    element: <UtilitySetupLanding />,
  },
  {
    path: "/",
    element: <UtilitySetupLanding />,
  },
  {
    path: "/utility/utility-setup/core-settings",
    element: <CoreSystemSettings />,
  },
  {
    path: "/utility/utility-setup/calendar",
    element: <CalenderLanding />,
  },
  {
    path: "/utility/utility-setup/id-config",
    element: <IdConfigLanding />,
  },
  {
    path: "/utility/utility-setup/utility-admin-dashboard",
    element: <UtilityAdminDashboard />,
  },
  {
    path: "/utility/utility-setup/user-management",
    element: <UserMgmtLanding />,
  },
  // {
  //   path: "/onboarding/utility-setup/tariff",
  //   element: <TarrifList />,
  // },
  // {
  //   path: "/plan-tarrif",
  //   element: <TarrifList />,
  // },
  // {
  //   path: "/plan-tarrif/tariff/:action",
  //   element: <TariffAddForm />,
  // },

  {
    path: "/plan-tarrif/plan/bulk-edit",
    element: <BulkEditPlanStepper />,
  },
  {
    path: "/plan-tarrif/plan/:action",
    element: <CreatePlan />,
  },
  {
    path: "/plan-tarrif/plan/:action/:planId?",
    element: <CreatePlan />,
  },
  {
    path: "/plan-tarrif/plan-tarrif-landing",
    element: <PlansAndTariffLanding />,
  },
  {
    path: "/plan-tarrif/plan/view/:id",
    element: <PlanDetailLanding />,
  },
  {
    path: "/utility/utility-setup/service-area",
    element: <ServiceAreaLanding />,
  },
  {
    path: "/utility/utility-setup/service-area/view/:code",
    element: <ServiceAreaDetailRoute />,
  },
  {
    path: "/utility/utility-setup/service-area/unit/view/:code",
    element: <UnitDetailView />,
  },
  {
    path: "/utility/utility-setup/parameter-registry",
    element: <ParameterRegistryList />,
  },
];
